import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';
import ChildBottomNav from './ChildBottomNav';
import eyeLogo from '../assets/relationprotector-eye.svg';

const NAV_ITEMS = [
  { path: '/child', icon: '🏠', label: 'Home' },
  { path: '/child/permissions', icon: '🛡️', label: 'Permissions' },
  { path: '/child/chat', icon: '💬', label: 'Chat' },
  { path: '/child/help', icon: '🤖', label: 'AI Guide' },
  { path: '/child/settings', icon: '⚙️', label: 'Settings' },
];

const pageTitles = {
  '/child': 'Child Home',
  '/child/permissions': 'Permissions',
  '/child/chat': 'Chat with Parent',
  '/child/help': 'AI Help Guide',
  '/child/settings': 'Settings',
};

export default function ChildLayout() {
  const { user, logout } = useAuth();
  const { isConnected } = useSocket();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    localStorage.removeItem('selectedRole');
    navigate('/');
  };

  return (
    <div className="app-layout">
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon"><img src={eyeLogo} alt="RelationProtector" className="brand-logo-img" /></div>
          <div className="sidebar-logo-text">
            <h2>RelationProtector</h2>
            <span>Child App</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <span className="nav-section-label">My Space</span>
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={() => {
                  navigate(item.path);
                  setSidebarOpen(false);
                }}
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">
              {user?.name?.[0]?.toUpperCase() || 'C'}
            </div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user?.name || 'Child'}</div>
              <div className="sidebar-user-role">Child Account</div>
            </div>
            <button
              className="btn btn-ghost btn-sm btn-icon"
              onClick={handleLogout}
              title="Logout"
            >
              🚪
            </button>
          </div>
        </div>
      </aside>

      <div className="main-content">
        <header className="topbar">
          <div className="topbar-title">
            Child<span>Zone</span> — {pageTitles[location.pathname] || 'Child Home'}
          </div>
          <div className="topbar-actions">
            <div className={`connection-badge ${isConnected ? '' : 'disconnected'}`}>
              <span className="connection-dot" />
              {isConnected ? 'Connected' : 'Offline'}
            </div>
            <button
              className="btn btn-ghost btn-sm"
              onClick={() => setSidebarOpen((o) => !o)}
              style={{ display: 'none' }}
            >
              ☰
            </button>
          </div>
        </header>

        <main className="page-content">
          <Outlet />
        </main>
      </div>

      <ChildBottomNav />
    </div>
  );
}
